"use strict";
/**
 * Pro Section Constructor
 */
wp.customize.sectionConstructor['epsilon-section-pro'] = wp.customize.Section.extend({
    attachEvents: function () {
    },
    isContextuallyActive: function () {
        return true;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/sections/section-pro.ts
// module id = 31
// module chunks = 0